import * as Linking from 'expo-linking';
import { type Href, Redirect, useNavigation, usePathname } from 'expo-router';
import { isWeb } from 'smoothie';

import NotFound from '../common/components/NotFound';
import { getWebUrl } from '../lib/Web';

// Mapping of legacy NextJS routes to their counterparts in the RN/RNW app.
const WEB_TO_MOBILE_ROUTE_MAPPINGS: Record<string, string> = {
    '/banking/statements': '/banking/documents',
    '/banking/savings': '/home/banking',
    '/dashboard/account-details': '/home/banking',
};

// Routes that are not supported on the mobile platform.
const WEB_ONLY_ROUTES = ['/sign-up', '/start-membership', '/auth/fdx'];

const NotFoundScreen = () => {
    const navigation = useNavigation();
    const { routes = [] } = navigation.getState() ?? {};
    const pathname = usePathname();
    const isRouteWebOnly = WEB_ONLY_ROUTES.some((route) =>
        pathname.includes(route),
    );

    // On native, handle web-only routes by redirecting to the web app via their default browser on device.
    // This is necessary because members can click on a universal link that open the mobile app, but the route does not exist.
    if (!isWeb && isRouteWebOnly) {
        const url = `${getWebUrl()}/${routes[routes.length - 1]?.path ?? ''}`;
        void Linking.openURL(url);
        return <Redirect href="/" />;
    }

    const matchedPath = WEB_TO_MOBILE_ROUTE_MAPPINGS[pathname];

    return matchedPath != null ? (
        <Redirect href={matchedPath as Href} />
    ) : (
        <NotFound />
    );
};

export default NotFoundScreen;
